if (!customElements.get('product-custom-size')) {
  customElements.define(
    'product-custom-size',
    class ProductCustomSize extends HTMLElement {
      connectedCallback() {
        this.inputs = [...this.querySelectorAll('[data-custom-size-input]')];
        this.errorMessage = this.querySelector('[data-custom-size-error]');
        this.variantIds = (this.dataset.variantIds || '').split(',');
        this.form = this.closest('form');
        this.variantInput = this.form?.querySelector('[name=id]');

        this.onVariantChange = this.onVariantChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onInput = this.onInput.bind(this);
        // The theme dispatches `change` on input[name=id] whenever another variant is picked.
        this.variantInput?.addEventListener('change', this.onVariantChange);
        // Capture phase: runs before ProductForm's own submit handler, so invalid values block the add.
        this.form?.addEventListener('submit', this.onSubmit, true);
        this.addEventListener('input', this.onInput);
        this.onVariantChange();
        this.onInput();
      }

      disconnectedCallback() {
        this.variantInput?.removeEventListener('change', this.onVariantChange);
        this.form?.removeEventListener('submit', this.onSubmit, true);
        this.removeEventListener('input', this.onInput);
      }

      get active() {
        return this.variantIds.includes(this.variantInput?.value);
      }

      // Disabled fields aren't submitted, so other variants add no Breite/Tiefe properties.
      onVariantChange() {
        const active = this.active;
        this.hidden = !active;
        this.inputs.forEach((input) => {
          input.disabled = !active;
          input.required = active;
          this.propertyFor(input).disabled = !active;
        });
        this.setError(false);
      }

      // The visible number input has no name; its hidden twin carries the line item property "<n> cm".
      propertyFor(input) {
        return input.closest('.form-field').querySelector('[data-custom-size-property]');
      }

      onInput() {
        this.inputs.forEach((input) => {
          const value = input.value.trim();
          this.propertyFor(input).value = value ? `${value} cm` : '';
        });
        if (!this.errorMessage.hidden && this.firstInvalid() === undefined) this.setError(false);
      }

      isValid(input) {
        const value = input.value.trim();
        return /^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= 90;
      }

      firstInvalid() {
        return this.inputs.find((input) => !this.isValid(input));
      }

      onSubmit(event) {
        if (!this.active) return;
        const invalid = this.firstInvalid();
        if (!invalid) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.setError(true);
        invalid.focus();
      }

      setError(show) {
        this.errorMessage.hidden = !show;
        this.errorMessage.textContent = show ? this.dataset.requiredText || '' : '';
      }
    }
  );
}
